import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material';
import { TranslationService } from './translation.service';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  constructor(private translationService: TranslationService) {
    super();
    
    // Subscribe to language changes
    this.translationService.langChange.subscribe(() => {
      this.updateLabels();
    });
    
    // Set initial labels
    this.updateLabels();
  }

  private updateLabels() {
    this.itemsPerPageLabel = this.translationService.translate('GLOBAL.PAGINATION.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translationService.translate('GLOBAL.PAGINATION.NEXT_PAGE');
    this.previousPageLabel = this.translationService.translate('GLOBAL.PAGINATION.PREVIOUS_PAGE');
    this.firstPageLabel = this.translationService.translate('GLOBAL.PAGINATION.FIRST_PAGE');
    this.lastPageLabel = this.translationService.translate('GLOBAL.PAGINATION.LAST_PAGE');
    
    // Trigger change detection
    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.translationService.translate('GLOBAL.PAGINATION.RANGE_PAGE_LABEL_1', { length });
    }
    
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    
    return this.translationService.translate('GLOBAL.PAGINATION.RANGE_PAGE_LABEL_2', {
      startIndex: startIndex + 1,
      endIndex,
      length
    });
  }
}
